import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import './OfferDetail.css';

function OfferDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    fetchOffer();
  }, [id]);

  const fetchOffer = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/offers/${id}`);
      setOffer(response.data.data);
    } catch (error) {
      console.error('Teklif yüklenemedi:', error);
      alert('Teklif bulunamadı');
      navigate('/offers');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    if (!window.confirm('Bu teklifi onaylamak istediğinizden emin misiniz?')) return;
    
    try {
      await api.put(`/offers/${id}/approve`);
      alert('Teklif onaylandı!');
      fetchOffer();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

  const handleReject = async () => {
    const reason = prompt('Red nedeni:');
    if (!reason) return;
    
    try {
      await api.put(`/offers/${id}/reject`, { reason });
      alert('Teklif reddedildi!');
      fetchOffer();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

  const handleSendEmail = async () => {
    if (!window.confirm('Teklif müşteriye email ile gönderilecek. Onaylıyor musunuz?')) return;
    
    try {
      await api.post(`/offers/${id}/send`);
      alert('Teklif başarıyla gönderildi!');
      fetchOffer();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'Gönderim başarısız'));
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Bu teklifi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!')) {
      return;
    }
    
    try {
      await api.delete(`/offers/${id}`);
      alert('Teklif silindi!');
      navigate('/offers');
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'Teklif silinemedi'));
    }
  };

  const handleSubmitForApproval = async () => {
    if (!window.confirm('Bu teklifi onaya göndermek istediğinizden emin misiniz?')) {
      return;
    }
    
    try {
      await api.put(`/offers/${id}/submit`);
      alert('Teklif onaya gönderildi!');
      fetchOffer();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

const handleDownloadPDF = () => {
    window.open(`https://teklif.mimbytes.tr/api/offers/pdf/${offer.pdf_token}`, '_blank');
  };

  const handleSendWhatsApp = () => {
    if (!offer.customer_phone) {
      alert('Müşteri telefon numarası bulunamadı!');
      return;
    }
    
    const phone = offer.customer_phone.replace(/[^0-9]/g, '');
    const pdfUrl = `https://teklif.mimbytes.tr/api/offers/pdf/${offer.pdf_token}`;
    const message = `Sayın ${offer.customer_name},\n\nTeklifimizi ekte bulabilirsiniz:\n\n${pdfUrl}\n\nTeklif No: ${offer.offer_number}\nTutar: ${offer.total} ${offer.currency}\n\nSaygılarımızla,\nMIM Bytes`;
    
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const getStatusBadge = (status) => {
    const badges = {
      draft: { text: 'Taslak', class: 'badge-draft' },
      pending: { text: 'Onay Bekliyor', class: 'badge-pending' },
      approved: { text: 'Onaylandı', class: 'badge-approved' },
      sent: { text: 'Gönderildi', class: 'badge-sent' },
      rejected: { text: 'Reddedildi', class: 'badge-rejected' }
    };
    const badge = badges[status] || { text: status, class: '' };
    return <span className={`badge ${badge.class}`}>{badge.text}</span>;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('tr-TR');
  };

  const formatCurrency = (amount, currency) => {
    const symbols = { EUR: '€', USD: '$', TRY: '₺', GBP: '£' };
    const numAmount = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
    return `${numAmount.toFixed(2)} ${symbols[currency] || currency}`;
  };

  if (loading) {
    return <div className="loading-page">Yükleniyor...</div>;
  }

  if (!offer) {
    return <div className="loading-page">Teklif bulunamadı</div>;
  }

  const isAdmin = user?.role === 'admin';
  const canApprove = isAdmin && offer.status === 'pending';
  const canSend = offer.status === 'approved';

  return (
    <div className="offer-detail-page">
      <div className="page-header">
        <div>
          <h1>Teklif Detayı: {offer.offer_number}</h1>
          {getStatusBadge(offer.status)}
        </div>
        <button className="btn-back" onClick={() => navigate('/offers')}>
          ← Geri
        </button>
      </div>

      <div className="action-buttons">
        <button className="btn-action" onClick={handleDownloadPDF}>
          📄 PDF İndir
        </button>
        
        {/* WhatsApp Gönder Butonu - Sadece telefon varsa göster */}
        {offer.customer_phone && (
          <button 
            className="btn-action" 
            style={{background: '#25D366', color: 'white'}}
            onClick={handleSendWhatsApp}
          >
            📱 WhatsApp Gönder
          </button>
        )}
        
        <button className="btn-action" onClick={() => navigate(`/offers/${id}/scope`)}>
          📝 Kapsam Düzenle
        </button>

        {/* Draft için: Herkes silebilir */}
        {offer.status === 'draft' && (
          <>
            <button className="btn-edit" onClick={() => navigate(`/offers/${id}/edit`)}>
              ✏️ Düzenle
            </button>
            <button className="btn-submit" onClick={handleSubmitForApproval}>
              ✓ Onaya Gönder
            </button>
            <button className="btn-delete" onClick={handleDelete}>
              🗑️ Sil
            </button>
          </>
        )}
        
        {/* Rejected için: Düzenle + Onaya Gönder + (Admin ise Sil) */}
        {offer.status === 'rejected' && (
          <>
            <button className="btn-edit" onClick={() => navigate(`/offers/${id}/edit`)}>
              ✏️ Düzenle
            </button>
            <button className="btn-submit" onClick={handleSubmitForApproval}>
              ✓ Onaya Gönder
            </button>
            {isAdmin && (
              <button className="btn-delete" onClick={handleDelete}>
                🗑️ Sil
              </button>
            )}
          </>
        )}
        
        {/* Admin için Pending tekliflerde: Onayla + Reddet */}
        {canApprove && (
          <>
            <button className="btn-approve" onClick={handleApprove}>
              ✓ Onayla
            </button>
            <button className="btn-reject" onClick={handleReject}>
              ✗ Reddet
            </button>
          </>
        )}
        
        {/* Approved teklifler için: Email Gönder + Admin ise Sil */}
        {canSend && (
          <>
            <button className="btn-send" onClick={handleSendEmail}>
              📧 Email Gönder
            </button>
            {isAdmin && (
              <button className="btn-delete" onClick={handleDelete}>
                🗑️ Sil
              </button>
            )}
          </>
        )}

        {/* Sent teklifler için: Admin ise Sil */}
        {offer.status === 'sent' && isAdmin && (
          <button className="btn-delete" onClick={handleDelete}>
            🗑️ Sil
          </button>
        )}
      </div>

      <div className="detail-sections">
        <div className="detail-section">
          <h2>👤 Müşteri Bilgileri</h2>
          <div className="info-grid">
            <div className="info-item">
              <label>Müşteri Adı:</label>
              <span>{offer.customer_name}</span>
            </div>
            <div className="info-item">
              <label>İlgili Kişi:</label>
              <span>{offer.contact_person || '-'}</span>
            </div>
            <div className="info-item">
              <label>Adres:</label>
              <span>{offer.customer_address || '-'}</span>
            </div>
            <div className="info-item">
              <label>Vergi No:</label>
              <span>{offer.customer_tax_no || '-'}</span>
            </div>
            <div className="info-item">
              <label>Vergi Dairesi:</label>
              <span>{offer.customer_tax_office || '-'}</span>
            </div>
          </div>
        </div>

        <div className="detail-section">
          <h2>📋 Teklif Bilgileri</h2>
          <div className="info-grid">
            <div className="info-item">
              <label>Teklif No:</label>
              <span>{offer.offer_number}</span>
            </div>
            <div className="info-item">
              <label>Teklif Tarihi:</label>
              <span>{formatDate(offer.offer_date)}</span>
            </div>
            <div className="info-item">
              <label>Geçerlilik:</label>
              <span>{offer.validity_date ? formatDate(offer.validity_date) : '-'}</span>
            </div>
            <div className="info-item">
              <label>Para Birimi:</label>
              <span>{offer.currency}</span>
            </div>
            <div className="info-item">
              <label>Hazırlayan:</label>
              <span>{offer.prepared_by}</span>
            </div>
          </div>
          {offer.intro_text && (
            <div className="intro-text">
              <label>Ön Yazı:</label>
              <p>{offer.intro_text}</p>
            </div>
          )}
        </div>

        <div className="detail-section">
          <h2>📦 Ürünler</h2>
          <div className="items-table">
            <table>
              <thead>
                <tr>
                  <th>Ürün Kodu</th>
                  <th>Ürün Adı</th>
                  <th>Açıklama</th>
                  <th>Miktar</th>
                  <th>Birim Fiyat</th>
                  <th>İskonto</th>
                  <th>Toplam</th>
                </tr>
              </thead>
              <tbody>
                {offer.items?.map((item, index) => (
                  <tr key={index}>
                    <td><strong>{item.product_code}</strong></td>
                    <td>{item.product_name}</td>
                    <td><small>{item.description || '-'}</small></td>
                    <td>{item.quantity} AD</td>
                    <td>{formatCurrency(item.unit_price, offer.currency)}</td>
                    <td>%{item.discount_percent}</td>
                    <td><strong>{formatCurrency(item.total_price, offer.currency)}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="totals-section">
          <div className="totals">
            <div className="total-row">
              <span>Ara Toplam:</span>
              <strong>{formatCurrency(offer.subtotal, offer.currency)}</strong>
            </div>
            <div className="total-row">
              <span>KDV (%{offer.kdv_rate}):</span>
              <strong>{formatCurrency(offer.kdv_amount, offer.currency)}</strong>
            </div>
            <div className="total-row grand-total">
              <span>GENEL TOPLAM:</span>
              <strong>{formatCurrency(offer.total, offer.currency)}</strong>
            </div>
          </div>
        </div>

        {offer.rejection_reason && (
          <div className="detail-section rejection-section">
            <h2>✗ Red Nedeni</h2>
            <p className="rejection-reason">{offer.rejection_reason}</p>
          </div>
        )}

        {offer.has_maintenance && (
          <div className="detail-section">
            <h2>🔧 Bakım Anlaşması</h2>
            <div className="info-grid">
              <div className="info-item">
                <label>Bakım Süresi:</label>
                <span>1 Yıl</span>
              </div>
              {offer.maintenance_start_date && (
                <div className="info-item">
                  <label>Başlangıç Tarihi:</label>
                  <span>{formatDate(offer.maintenance_start_date)}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OfferDetail;
